import React, { useCallback } from "react"

import { useLocation } from "store/contexts/location"

import Icon from "icons"
import { ShareMenu, ShareButton } from "./styles"

const ShareSection = ({ video }) => {
  const { location } = useLocation()

  const shareFBHandler = useCallback(() => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(location.href)}`,
      "Facebook",
      "height=300,width=500",
    )
  }, [location.href])

  const shareTwitterHandler = useCallback(() => {
    const shareText = encodeURIComponent(`Watch ${video.title}`)

    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        location.href,
      )}&text=${shareText}&via=mindbodygreen`,
      "Twitter",
      "height=300,width=500",
    )
  }, [location.href, video])

  const sharePinterestHandler = useCallback(() => {
    const description = encodeURIComponent(`Watch ${video.title}`)
    const media = encodeURIComponent(video.image)

    window.open(
      `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(
        location.href,
      )}&media=${media}&description=${description}`,
      "Pinterest",
    )
  }, [location.href, video])

  return (
    <ShareMenu>
      <ShareButton onClick={shareFBHandler}>
        <Icon id="facebook-share-icon-2" title="Share on Facebook" height={39} width={39} />
      </ShareButton>
      <ShareButton onClick={shareTwitterHandler}>
        <Icon id="twitter-share-icon-2" title="Share on Twitter" height={39} width={39} />
      </ShareButton>
      <ShareButton onClick={sharePinterestHandler}>
        <Icon id="pinterest-share-icon-2" title="Share on Pinterest" height={39} width={39} />
      </ShareButton>
    </ShareMenu>
  )
}

export default ShareSection
